<template>
    <div class="notification-list-view" ref="notificationListView" :class="{ popup: !groupByDate }">
        <a-spin :spinning="loading">
            <div class="empty-notifications" v-if="!Object.keys(groups).length">
                <template v-if="minimized">
                    <div class="material-icons notification-shake">notifications_active</div>
                    <div class="empty-message">{{ $t('notification.noNotificationTitle1') }}</div>
                    <SupsisButton :ghost="true" :small="true" @click="redirectNotificationSettings"
                        >{{ $t('search.allNotificationSettings') }}</SupsisButton
                    >
                </template>
                <template v-else>
                    <div class="material-icons notification-shake">notifications_active</div>
                    <div class="empty-message-title">{{ $t('notification.noNotificationTitle2') }}</div>
                    <div class="empty-message">
                        {{ $t('notification.noNotificationDesc2') }}
                    </div>
                    <SupsisButton :ghost="true" :small="true" @click="redirectNotificationSettings"
                        >{{ $t('notification.adjustNow') }}</SupsisButton
                    >
                </template>
            </div>
            <div class="groups">
                <div class="group" :key="date" v-for="date of Object.keys(groups)">
                    <div class="date" v-if="groupByDate">{{ $moment(date, "YYYY-MM-DD").format("LL") }}</div>
                    <div class="items">
                        <NotificationCard
                            :notification="notification"
                            @markRead="markRead"
                            @markUnread="markUnread"
                            :key="notification._id"
                            onCardClick="{onCardClick}"
                            v-for="notification of groups[date]"
                        />
                    </div>
                </div>
            </div>
        </a-spin>
    </div>
</template>
<script>
import Vue from "vue";
import moment from "moment";
import _ from "lodash";
import NotificationCard from "./NotificationCard.vue";
import SupsisButton from "../Settings/components/SupsisButton.vue";
import SYSTEM_PUBSUB from "../../../utils/systemPubSub";

export default Vue.extend({
    name: "NotificationListView",
    components: { NotificationCard, SupsisButton },
    props: {
        notifications: {
            type: Array,
            default: () => [],
        },
        groupByDate: {
            type: Boolean,
            default: false,
        },
        minimized: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        listeners: [],
    }),
    computed: {
        groups() {
            const groups = {};
            _.orderBy(this.notifications, ["createdAt"], ["desc"]).forEach((notification) => {
                const date = this.groupByDate
                    ? moment(notification.createdAt).format("YYYY-MM-DD")
                    : moment().format("YYYY-MM-DD HH:mm");
                if (!groups[date]) {
                    groups[date] = [];
                }
                groups[date].push(notification);
            });
            console.log("groups", groups);
            return groups;
        },
    },
    methods: {
        redirectNotificationSettings() {
            this.$router.push("/settings/notifications");
        },
        markRead(nId) {
            SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.NOTIFICATION_UPDATED, {
                id: nId,
                seen: true,
            });
        },
        markUnread(nId) {
            SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.NOTIFICATION_UPDATED, {
                id: nId,
                seen: false,
            });
        },
    },
    mounted() {
        const notificationListView = this.$refs.notificationListView;
        const listener = (e) => {
            const scrollHeight = notificationListView.offsetHeight + notificationListView.scrollTop;
            console.log("scrol", { scrollHeight, x: notificationListView.scrollHeight });
            if (scrollHeight + 0.5 >= notificationListView.scrollHeight) {
                this.$emit("load-more");
            }
        };
        this.listeners.push(() => notificationListView?.removeEventListener("scroll", listener));
        notificationListView?.addEventListener("scroll", listener);
    },
    beforeDestroy() {
        this.listeners.map((fn) => fn());
    },
});
</script>

<style lang="scss">
.notification-list-view {
    height: 100%;
    overflow: auto;
    font-family: Inter, sans-serif;

    &::-webkit-scrollbar {
        width: 4px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background: #C9BBF6;
        border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #B8A5E8;
    }

    .empty-notifications {
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 40px 20px;
        gap: 12px;
        user-select: none;

        .empty-message-title {
            font-weight: 600;
            font-size: 18px;
            color: #1A1D1F;
            font-family: Inter, sans-serif;
        }

        .empty-message {
            font-size: 14px;
            font-weight: 400;
            color: #6B7280;
            font-family: Inter, sans-serif;
        }

        .notification-shake {
            font-weight: 400;
            font-size: 48px;
            color: #9CA3AF;
        }
    }

    .groups {
        display: flex;
        flex-direction: column;
        gap: 12px;
        padding: 8px;

        .group {
            .date {
                position: relative;
                display: inline;
                font-size: 12px;
                font-weight: 600;
                color: #6B7280;
                padding: 0 12px;
                font-family: Inter, sans-serif;

                &:after {
                    display: none;
                }
            }

            .items {
                display: flex;
                flex-direction: column;
                border: none;
                border-radius: 8px;
                background: #FFFFFF;
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

                .notification-card:last-child {
                    border-bottom: none;
                }

                .notification-card {
                    display: flex;
                    justify-content: space-between;
                    border-bottom: 1px solid #E8E8EA;
                    background-color: #FFFFFF;
                    padding: 16px;
                    border-radius: 0;
                    cursor: pointer;
                    transition: all 0.2s ease;

                    &:hover {
                        background-color: #F5F3FF;
                    }

                    &:first-child {
                        border-radius: 8px 8px 0 0;
                    }

                    &:last-child {
                        border-radius: 0 0 8px 8px;
                        border-bottom: none;
                    }

                    .activity-card {
                        border-bottom: none !important;
                    }

                    &.seen {
                        background: #FFFFFF;
                        opacity: 0.7;
                    }

                    .tag {
                        background-image: #FFFFFF;
                        border: 1px solid #E8E8EA;
                        line-height: 20px;
                        padding: 4px 8px;
                        border-radius: 6px;
                        cursor: inherit;
                        display: inline-block;
                        color: #1A1D1F;
                        font-size: 12px;
                        font-weight: 500;
                        position: relative;
                        margin-left: 5px;
                        font-family: Inter, sans-serif;
                    }

                    .left {
                        display: flex;
                        gap: 12px;
                        align-items: center;

                        .avatar-wrapper {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            position: relative;

                            .icon {
                                display: flex;
                                width: 24px;
                                height: 24px;
                                border-radius: 50%;
                                position: absolute;
                                align-content: center;
                                align-items: center;
                                justify-content: center;
                                right: -8px;
                                bottom: -8px;
                                background-color: #FFFFFF;
                                color: #6B7280;
                                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

                                .MuiSvgIcon-root {
                                    color: #6B7280;
                                    width: 18px;
                                    height: 18px;
                                }
                            }
                        }
                    }

                    .right {
                        display: flex;
                        gap: 8px;
                        align-items: center;
                        justify-content: center;
                    }
                }
            }
        }
    }

    &.popup {
        max-height: calc(85vh - 90px);
        overflow: auto;

        .items {
            border: none !important;
            box-shadow: none !important;
        }

        .notification-card {
            padding: 12px 16px !important;
            border-radius: 8px !important;
            margin-bottom: 4px;

            &:last-child {
                margin-bottom: 0;
            }

            .notification-content {
                line-height: 1.5;
                font-size: 13px;
                font-family: Inter, sans-serif;
            }
        }
    }
}
</style>
